<template>
    <div
        :class="
            'uk-height-1-1 card-select' +
            (isSelected ? ' selected' : '') +
            (fillSelected ? ' fill' : '') +
            (isRound ? ' round' : '') +
            (isMuted ? ' muted' : '') +
            (isDisabled ? ' disabled' : '') +
            (isError ? ' error' : '') +
            (withLineHeight ? ' lineheight' : '')
        ">
        <div class="struct">
            <Icon v-if="false" class="uk-margin-small-right" icon="check" />
            <slot />
        </div>
    </div>
</template>

<script>
import Icon from '@/components/generic/Icon';

export default {
    name: 'LabelSelect',
    components: {Icon},
    props: {
        isSelected: Boolean,
        isError: Boolean,
        withLineHeight: Boolean,
        isDisabled: Boolean,
        isMuted: Boolean,
        isRound: Boolean,
        fillSelected: Boolean,
    },
};
</script>

<style lang="scss" scoped>
.struct {
    padding: 5px 5px !important;
}

.card-select {
    transition: border-color 0.25s linear;
    margin-top: 2px !important;
    border: 2px solid #e5e5e5;
    width: 100%;
    background: none !important;
    color: $site-background !important;
    cursor: pointer;

    //transition: background-color .25s linear,  color .25s linear, border-color .25s linear;

    &.disabled {
        border: 1px solid #e5e5e5 !important;
        cursor: not-allowed !important;
    }

    &.muted {
        cursor: initial !important;
    }

    &.selected {
        border-color: $theme-background !important;
        background-color: $theme-background !important;
        color: $theme-color-hover !important;

        &.fill {
            border-width: 2px;
        }

        &.info {
            border-color: $info-color !important;
            background-color: $info-color !important;
            color: $site-color-hover !important;
        }

        &.lunacart-theme-selected {
            border-color: $info-color !important;
            background-color: $info-color !important;
            color: $site-color-hover !important;
        }
    }

    &:hover {
        border-color: #949393;
    }

    &.error {
        background: rgba(240, 80, 80, 0.15) !important;
        border-color: $theme-background !important;
    }

    &.lineheight {
        line-height: 50px;
    }

    &.round {
        border-radius: $border-radius-next;
    }
}
</style>
